import React from 'react';
import moment from 'moment-timezone';
import { BellOutlined } from '@ant-design/icons';
import { formatReminderTime, formatUpcomingReminder } from '../../data/workOrderStarLabels';
import useReminderNow from '../../hooks/useReminderNow';
import useReminderRinging from '../../hooks/useReminderRinging';

interface Props {
	workOrderId: number;
	remindAt: moment.Moment;
}

// Footer line on a work order row: "Reminder: 4:30 PM" (red) once it rings, otherwise
// the countdown "Reminder in 2h 30m".
const WorkOrderReminderLine: React.FC<Props> = ({ workOrderId, remindAt }) => {
	const now = useReminderNow(remindAt);
	if (useReminderRinging(workOrderId, remindAt)) {
		return (
			<span className="inline-flex items-center gap-1 text-character-danger">
				<BellOutlined />
				{`Reminder: ${formatReminderTime(remindAt, now)}`}
			</span>
		);
	}
	return (
		<span className="inline-flex items-center gap-1" title={formatReminderTime(remindAt, now)}>
			<BellOutlined />
			{formatUpcomingReminder(remindAt, now)}
		</span>
	);
};

export default WorkOrderReminderLine;
